export const TAG_RECOMMENDED = 1;
